<template>
  <b-container fluid id="event" class="page">
    <h1>{{ this.page.event_title }}</h1>
    <div class="details">
      <div>
        <span class="icon">
          <font-awesome icon="calendar" fixed-width />
        </span>
        <span>{{ this.page.date_begin }}</span>
        <span v-if="this.page.date_end != null && this.page.date_end != this.page.date_begin"> -
          {{ this.page.date_end }}</span>
      </div>

      <div>
        <span class="icon">
          <font-awesome icon="map-pin" fixed-width />
        </span>
        <span>{{ this.page.location }}</span>
      </div>
    </div>

    <div class="richtext" v-html="this.page.details"></div>

    <div class="tags d-flex">
      <font-awesome v-if="this.tags[0]" icon="tags" fixed-width />
      <ul class="tag-list">
        <li v-for="(tag, index) in this.tags" :key="index">
          <router-link :to="tag.id" tag="a">{{ tag.display_title }}</router-link>
        </li>
      </ul>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Event",
  props: ["page"],
  data: function () {
    console.log(this.page)
    return {
      tags: [],
      url: ''
    };
  },
  created() {
    this.url = process.env.VUE_APP_API_URL
    if (this.page.associated_members != []) {
      this.page.associated_members.forEach(element => {
        element.id = "/members/" + element.id;
        element.display_title = element.name;
        this.tags.push(element);
      });
    }
    if (this.page.associated_projects != []) {
      this.page.associated_projects.forEach(element => {
        element.id = "/projects" + element.id;
        element.display_title = element.display_title;
        this.tags.push(element);
      })
    }
    this.tags.sort((a, b) => {
      if (a.display_title < b.display_title) return -1;
      else return 1;
    });
  }
};
</script>

<style lang="scss">
#event {
  h1 {
    margin-bottom: 1.2em;
  }

  .details {
    margin-bottom: 1em;
    text-transform: uppercase;

    :not(:first-child) {
      margin-top: 0.7em;
    }

    .icon {
      margin-right: 0.7em;

      * {
        color: $secondary-color;
      }
    }
  }

  .tags {
    :first-child {
      margin-top: 0.25em;
    }

    .tag-list {
      padding-left: 1em;
      margin: 0;

      li {
        display: inline;
        text-transform: uppercase;

        * {
          color: $secondary-color !important;
        }

        &:not(:last-child):after {
          content: ", ";
        }
      }
    }
  }

  .richtext ul {
    list-style-type: disc;
    padding-left: 1.5rem;
  }

  .richtext ol {
    list-style-type: decimal;
    padding-left: 1.5rem;
  }
}
</style>